import { useRef } from "react"
import { Button, ButtonSize } from "../../../../components/Button"
import { useTextStorage, useImagePreload } from "../../../../hooks"

import {
  servicesDecor,
  services1Bg,
  services1Hq,
  services1Lq,
  services1Decor,
  services2Hq,
  services2Lq,
  services3Bg,
  services3Hq,
  services3Lq,
  services3Decor1,
  services3Decor2,
} from "../../../../assets/images"

import "./ServicesSection.scss"
import { useNavigate } from "react-router-dom"

export const ServicesSection: React.FC = () => {
  const { ts } = useTextStorage()
  const navigate = useNavigate()

  const services1HqRef = useRef<HTMLImageElement>(null)
  const services2HqRef = useRef<HTMLImageElement>(null)
  const services3HqRef = useRef<HTMLImageElement>(null)

  useImagePreload(services1Hq, services1HqRef)
  useImagePreload(services2Hq, services2HqRef)
  useImagePreload(services3Hq, services3HqRef)

  return (
    <div className="services-section">
      <div className="services-section--texts">
        <h2>{ts.pages.home.servicesSection.title}</h2>
        <p>{ts.pages.home.servicesSection.text}</p>
      </div>
      <div className="services-section--cards-container">
        <div className="services-section--card first">
          <span className="services-section--card--title">
            {ts.pages.home.servicesSection.cards[0].title}
          </span>
          <div className="services-section--card--pic-container">
            <img
              src={services1Bg}
              alt="services1-bg"
              className="services1-bg"
            />
            <img
              ref={services1HqRef}
              src={services1Hq}
              alt="services1-hq"
              className="services1-hq"
            />
            <img
              src={services1Lq}
              alt="services1-lq"
              className="services1-lq"
            />
          </div>
          <Button
            text={ts.pages.home.servicesSection.cards[0].buttonText}
            onClick={() => navigate("/services#animal")}
            size={ButtonSize.SM}
          />
          <img
            src={services1Decor}
            alt="services1-decor"
            className="services1-decor"
          />
        </div>
        <div className="services-section--card second">
          <span className="services-section--card--title">
            {ts.pages.home.servicesSection.cards[1].title}
          </span>
          <div className="services-section--card--pic-container">
            <img
              ref={services2HqRef}
              src={services2Hq}
              alt="services2-hq"
              className="services2-hq"
            />
            <img
              src={services2Lq}
              alt="services2-lq"
              className="services2-lq"
            />
          </div>
          <Button
            text={ts.pages.home.servicesSection.cards[1].buttonText}
            onClick={() => navigate("/services#portrait")}
            size={ButtonSize.SM}
          />
        </div>
        <div className="services-section--card third">
          <span className="services-section--card--title">
            {ts.pages.home.servicesSection.cards[2].title}
          </span>
          <div className="services-section--card--pic-container">
            <img
              src={services3Bg}
              alt="services3-bg"
              className="services3-bg"
            />
            <img
              ref={services3HqRef}
              src={services3Hq}
              alt="services3-hq"
              className="services3-hq"
            />
            <img
              src={services3Lq}
              alt="services3-lq"
              className="services3-lq"
            />
            <img
              src={services3Decor1}
              alt="services3-decor1"
              className="services3-decor1"
            />
            <img
              src={services3Decor2}
              alt="services3-decor2"
              className="services3-decor2"
            />
          </div>
          <Button
            text={ts.pages.home.servicesSection.cards[2].buttonText}
            onClick={() => navigate("/services#family")}
            size={ButtonSize.SM}
          />
        </div>
      </div>

      <img
        src={servicesDecor}
        alt="services-decor"
        className="services-section--decor"
      />
    </div>
  )
}
